import { removeTask, getTasksForComponent } from '../../../services/taskPersistence';
import { buildStreamingHistoryItem } from '../../streamingHistory';

/**
 * Источник «микрофон»: bit-streaming распознаёт речь по ходу разговора.
 *
 * Отличается от остальных тем, что задачи на бэкенде нет вовсе — сессия живёт
 * в памяти сервиса и стримит фразы в браузер. Поэтому и ключ у него свой
 * (sessionId), и восстановления после перезагрузки быть не может.
 */

const PERSIST_KEY = 'recognition-live';

/**
 * 🔴 Всегда null. Поток микрофона обрывается вместе с вкладкой: сессия на
 * сервере закрыта, звук больше не идёт. Показать «идёт запись» после
 * перезагрузки значило бы обещать запись, которой нет, — человек досидел бы до
 * конца встречи впустую. Заодно подчищаем обрывок, чтобы он не мозолил глаза в
 * списке активных задач.
 */
function restore() {
  getTasksForComponent(PERSIST_KEY).forEach((task) => removeTask(task.taskId));
  return null;
}

/** Запись Истории по остановленной сессии; null — пока запись идёт. */
function toHistoryItem(state) {
  return buildStreamingHistoryItem(state);
}

export const liveSource = { key: 'live', restore, toHistoryItem };
